module.exports = "https://static.wmbcdn.com/uniweb/images/4581eeae90024252a401bf4d3dccbcfa.svg";